<template>
  <v-btn
    block
    :color="color"
    :depressed="depressed"
    :disabled="disabled"
    :height="$vuetify.breakpoint.smAndDown ? '52px' : '72px'"
    :outlined="outlined"
    @click="$emit('click', $event)"
  >
    <span
      :class="($vuetify.breakpoint.smAndDown ? 'bold-16' : 'bold-24') + (outlined ? '' : ' white--text')"
    >
      <slot></slot>
    </span>
  </v-btn>
</template>

<script>
export default {
  props: {
    color: String,
    depressed: Boolean,
    disabled: Boolean,
    outlined: Boolean
  }
};
</script>

<style>
</style>
